import React, { useState, useRef, useImperativeHandle } from "react";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
  HStack,
  useDisclosure,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const ConfirmDialog = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [title, setTitle] = React.useState("");
  const [message, setMessage] = useState("");
  const dialogRef = useRef(undefined);

  const {
    cancelButtonProps = {},
    confirmButtonProps = {},
    onCancel = () => {},
    onConfirm = () => {},
  } = props;

  const handleConfirm = () => {
    onClose();
    onConfirm();
  }

  const handleCancel = () => {
    onClose();
    onCancel();
  }

  const displayDialog = ({ title, message }) => {
    setTitle(title);
    setMessage(message);
    onOpen();
  }

  useImperativeHandle(ref, () => ({
    displayDialog: displayDialog,
  }));

  return (
    <AlertDialog isOpen={isOpen} onClose={onClose} leastDestructiveRef={dialogRef}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {title}
          </AlertDialogHeader>

          <AlertDialogBody>
            {message}
          </AlertDialogBody>

          <AlertDialogFooter>
            <HStack spacing="2">
              <Button {...cancelButtonProps} onClick={handleCancel}>
                {t("system.dialogs.delete.buttons.cancel")}
              </Button>

              <Button colorScheme="blue" {...confirmButtonProps} onClick={handleConfirm}>
                {t("system.dialogs.delete.buttons.confirm")}
              </Button>
            </HStack>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
});

export default ConfirmDialog;
